var pgaSocialnetworks = [{
  id: 1,
  name: "facebook",
  link: "https://facebook.com/PGAofAmerica"
}, {
  id: 3,
  name: "linkedin",
  link: "https://www.linkedin.com/company/pga-of-america/"
}, {
  id: 4,
  name: "twitter",
  link: "https://twitter.com/PGA"
}, {
  id: 5,
  name: "youtube",
  link: "https://www.youtube.com/user/PGAofAmerica"
}];

export { pgaSocialnetworks as default };
